import EntryList from './EntryList'

function Receivable() {
    return <EntryList type="receber" title="Contas a Receber" />
}

export default Receivable
